<template>
  <div class="main">
    <a-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
    >
      <a-form-item><div class="login-type">管理员登录</div></a-form-item>
      <a-alert
        v-if="isLoginError"
        type="error"
        showIcon
        style="margin-bottom: 24px;"
        :message="errorMessage"
      />
      <a-form-item>
        <a-input
          size="large"
          type="text"
          placeholder="账户"
          v-decorator="[
            'account',
            {
              rules: [{ required: true, message: '登录名' }],
              validateTrigger: 'change'
            }
          ]"
        >
          <a-icon
            slot="prefix"
            type="user"
            :style="{ color: 'rgba(0,0,0,.25)' }"
          />
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-input
          size="large"
          type="password"
          autocomplete="false"
          placeholder="密码"
          v-decorator="[
            'password',
            {
              rules: [{ required: true, message: '请输入密码' }],
              validateTrigger: 'blur'
            }
          ]"
        >
          <a-icon
            slot="prefix"
            type="lock"
            :style="{ color: 'rgba(0,0,0,.25)' }"
          />
        </a-input>
      </a-form-item>
      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
          >登录</a-button
        >
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { timeFix } from "@/utils/util";

export default {
  data() {
    return {
      loginBtn: false,
      isLoginError: false,
      errorMessage: "",
      form: this.$form.createForm(this),
      state: {
        loginBtn: false
      }
    };
  },
  created() {},
  methods: {
    ...mapActions(["AdminLogin"]),
    //登录
    handleSubmit(e) {
      e.preventDefault();
      this.isLoginError = false;
      this.state.loginBtn = true;
      //进行校验
      this.form.validateFields(
        ["account", "password"],
        { force: true },
        (err, values) => {
          if (!err) {
            const loginParams = { ...values };
            this.AdminLogin(loginParams)
              .then(res => this.loginSuccess(res))
              .finally(() => {
                this.state.loginBtn = false;
              });
          } else {
            setTimeout(() => {
              this.state.loginBtn = false;
            }, 600);
          }
        }
      );
    },
    loginSuccess(res) {
      if (res && res.result == 0) {
        this.$router.push({ path: "/" });
        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: "欢迎",
            description: `${timeFix()}，欢迎回来`,
            duration: 2
          });
        }, 1000);
        this.isLoginError = false;
      }
    }
  }
};
</script>

<style lang="less">
.main {
  background-color: #ffffff;
  padding: 10px 40px;
  border-radius: 10px;
}
.user-layout-login {
  .login-type {
    padding-top: 20px;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    color: grey;
  }
  .ant-tabs-ink-bar {
    height: 0px;
  }
  .ant-input {
    border-radius: 10px !important;
  }
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
    font-size: 12px;
    border-radius: 10px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    width: 100%;
    border-radius: 10px;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
